export const paymentMethodHint = (currency) => {
  const code = String(currency || "").toUpperCase()
  if (code === "KES") return "Kenyan employers can pay with M-PESA at checkout."
  return ""
}

export const billingSummaryText = ({ amount, currency, usedUsdFallback, countryCurrency }) => {
  const due = formatBillingAmount(amount, currency)
  const fallback =
    usedUsdFallback && countryCurrency
      ? ` ${countryCurrency} is not available at checkout, so USD is used.`
      : " Charged in the currency for your company country."
  const mpesa = paymentMethodHint(currency)
  return `Amount due: ${due} (${currency}).${fallback}${mpesa ? ` ${mpesa}` : ""}`
}

export const formatBillingAmount = (amount, currency = "NGN") => {
  const n = Number(amount)
  const code = String(currency || "NGN").toUpperCase()
  if (!Number.isFinite(n)) return "—"
  try {
    return new Intl.NumberFormat("en", {
      style: "currency",
      currency: code,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n)
  } catch {
    return `${code} ${n.toLocaleString("en", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
  }
}
